<template>
  <li>
    <a
      :class="{active: active}"
      :title="title"
      class="sidebar-tooltip"
      data-boundary="window"
      data-placement="right"
      data-toggle="tooltip"
      :href="url"
    >
      <i :class="iconClass" class="fas mr-2"></i>
      <span>{{title}}</span>
    </a>
  </li>
</template>

<script>
export default {
  name: "SidebarElement",

  props: {
    active: {
      type: Boolean,
      default: false,
      required: false
    },
    title: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    iconClass: {
      required: false,
      type: String,
      default: ""
    }
  },

  data() {
    return {};
  },

  methods: {},

  computed: {}
};
</script>

<style scoped>
</style>